import type { EvProductType } from "@/features/ev/EvProductType";
import type { EvSetType } from "@/features/ev/EvSetType";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface EvHistoricalPositionsResponseModel {
	readonly date: string;
	readonly estimatedValue: number;
	readonly marketPrice: number;
	readonly marketPriceDelta: number;
}

export const useEvHistoricalPositions = (evSetType: EvSetType, evProductType: EvProductType, days: number) => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["evHistoricalPositions", evSetType, evProductType, days],
		queryFn: () => {
			return http<EvHistoricalPositionsResponseModel[]>({
				method: "GET",
				url: `/ev/breakdown/historical-positions?setType=${evSetType}&productType=${evProductType}&days=${days}`
			});
		},
		placeholderData: x => x
	});
};
